import PropTypes from "prop-types";
import React, { Fragment } from "react";
// import { withRouter, matchPath } from "react-router";

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from "react-html-parser";

import Link from "../../../../components/Link";
// ^^ A Link element for our custom history router.

import PopupPageDecoration from "../../../../views/HomeView/PopupPages/PopupPageDecoration";

import Form, { FormRow, UploadButton, TextField, SubmitButton } from "../../../../components/Form";

import SEO from "../../../../../../global-components/seo";

import * as ROUTES from "../../../../constants/routes.js";

import "./style.scss";

class ThankYouPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      contentReady: false,
    };

    this.vars = {
      //
    };
  }

  componentDidMount() {
    // this.timerID = setInterval(() => this.tick(), 1000);

    this.init();
  }

  componentWillUnmount() {
    // clearInterval(this.timerID);
  }

  componentDidUpdate(prevProps) {
    var Z = this;
    if (this.props.currentRoute !== prevProps.currentRoute) {
      Z.getRoleData();
    }
  }

  init = () => {
    const Z = this;

    Z.getRoleData();
  };

  getRoleData = () => {
    const Z = this;

    if (Z.props.setReady != null) {
      Z.props.setReady(false);
    }
    Z.setState({
      contentReady: false,
    });

    /*  TO DO:
     *      Make an API call to Greenhouse to get page content
     */

    // setTimeout simulates API call request time:
    setTimeout(function () {
      Z.setState(
        {
          contentReady: true,
          roleLocation: "London",
          roleTitle: "\\Creative Director",
          roleDescription: `<p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
              <p>
                <b>What we'd like to see:</b>
              </p>
              <ul>
                <li>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </li>
                <li>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.
                </li>
              </ul>
              `,
        },
        () => {
          if (Z.props.setReady != null) {
            Z.props.setReady(Z.props.componentRoute, true);
          }
        }
      );
    }, 0);
  };

  submitApplication = () => {
    const Z = this;

    // ...

    let nextPage = ROUTES.CAREERS_THANK_YOU;

    var newHistoryState = {};
    var newHistoryTitle = "";
    window.history.pushState(newHistoryState, newHistoryTitle, nextPage);

    var popStateEvent = new PopStateEvent("popstate", {
      state: newHistoryState,
    });
    window.dispatchEvent(popStateEvent);
  };

  render() {
    var Z = this;

    var locationBadgeImage;
    if (Z.state.roleLocation == "London") {
      locationBadgeImage = require("../../../../../../assets/images/temp/locations/LDN.svg");
    } else {
      // ...
      locationBadgeImage = require("../../../../../../assets/images/temp/locations/LDN.svg");
    }

    return (
      <PopupPageDecoration isVertical={true}>
        <div className={`ThankYouPage`}>
          <div className="page-title-row">
            <div className="page-title">Thanks for your application.</div>
          </div>
          <div className="page-description">
            <p>We look forward to meeting you and our recruitment team will be in touch soon.</p>
            <p>
              In the meantime, to get to know us a little better, check this out and stay tuned to @tbwamal to meet some of the community that makes Media Arts
              Lab the special place it is.
            </p>
          </div>
          <div className="page-bottom-space"></div>
        </div>
      </PopupPageDecoration>
    );
  }
}

ThankYouPage.propTypes = {
  // currentPage: PropTypes.string,
  // roleId: PropTypes.string,
  componentRoute: PropTypes.string,
  currentRoute: PropTypes.object,
  setReady: PropTypes.func,
};

export default ThankYouPage;
